import { render } from "./ReferenceSampleBlock.vue?vue&type=template&id=2c135e68&scoped=true"
import script from "./ReferenceSampleBlock.vue?vue&type=script&lang=js"
export * from "./ReferenceSampleBlock.vue?vue&type=script&lang=js"

import "./ReferenceSampleBlock.vue?vue&type=style&index=0&id=2c135e68&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c135e68"]])

export default __exports__